import { render, staticRenderFns } from "./OrderCreateHome.vue?vue&type=template&id=b4324ffc&"
import script from "./OrderCreateHome.vue?vue&type=script&lang=js&"
export * from "./OrderCreateHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports